import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";

export class NewSearchWidgetEntityClickHandler extends ActionHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.entityClickHandler;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.sendEntityClickEvent(params);
    this.state.exitTrigger = NEW_SEARCH_WIDGET.ANALYTICS.NEXT_ACTION.entityClick;

    this.controller.action(ACTION_TYPES.onSearchClick, {isVisible: false});

    if ("scheduler" in window) {
      window.scheduler.postTask(() => this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onRecentFetch), {priority: 'background'});
    } else {
      this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onRecentFetch)
    }

    return params;
  }

  sendEntityClickEvent(params) {
    this.controller.action(ACTION_TYPES.storageEntity, {item: params.item});
    this.controller.action(ACTION_TYPES.entityClick, {
      entityId: params.item.id,
      entityName: params.item.nameForURL,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[params.item.objectType],
      currentLinkModel: params.item.linkModel.name,
      sportTypeId: params.item.sport.id,
      source: APP.ANALYTICS.SOURCES.search,
      subSource: this.calcSubSourceById(params.subSource)
    });
  }

  calcSubSourceById(id) {
    let subSource = 'none';
    if (id === NEW_SEARCH_WIDGET.LIST_ID.topAthletes || id === NEW_SEARCH_WIDGET.LIST_ID.topCompetitors || id === NEW_SEARCH_WIDGET.LIST_ID.topCompetitions) {
      subSource = 'suggested';
    } else if (id === NEW_SEARCH_WIDGET.LIST_ID.searchCompetitions || id === NEW_SEARCH_WIDGET.LIST_ID.searchCompetitors || id === NEW_SEARCH_WIDGET.LIST_ID.searchAthletes) {
      subSource = 'self-searched';
    } else if (id === NEW_SEARCH_WIDGET.LIST_ID.recentSearches) {
      subSource = 'recent';
    }

    return subSource;
  }
}
